<!--
  NOTES:
    - data-1p-ignore attribute is added to hide 1Password manager extension/helper from
      inputs by default: https://developer.1password.com/docs/web/compatible-website-design/
-->
<template lang="pug">
label.label(v-if="label" :for="$attrs.id || name") {{ label }}
FormField(v-if="name" v-slot="$field" :name="name")
  .relative.w-full
    InputText(
      v-model="$field.value"
      :class="inputClass"
      :type="revealed ? 'text' : 'password'"
      :id="$attrs.id || name"
      :autocomplete="$attrs.autocomplete || 'off'"
      :placeholder="$attrs.placeholder"
      data-1p-ignore
      fluid
    )
    button.eye-toggle(
      type="button"
      :aria-label="revealed ? 'Hide password' : 'Show password'"
      class="absolute right-3 top-1/2 -translate-y-1/2 text-canvas-400 hover:text-primary-600"
      @click="toggleRevealed"
      v-tooltip.top="'Show/Hide'"
    )
      i.ph(:class="revealed ? 'ph-eye-slash' : 'ph-eye'")
  Message(v-if="$field?.invalid && ($field?.touched || formSubmitted)" severity="error" size="small" variant="simple") {{ $field.error?.message }}

.relative.w-full(v-else)
  InputText(
    v-model="modelValue"
    :class="inputClass"
    :type="revealed ? 'text' : 'password'"
    :id="$attrs.id"
    :autocomplete="$attrs.autocomplete || 'off'"
    :placeholder="$attrs.placeholder"
    data-1p-ignore
    fluid
  )
  button.eye-toggle(
    type="button"
    :aria-label="revealed ? 'Hide password' : 'Show password'"
    class="absolute right-3 top-1/2 -translate-y-1/2 text-canvas-400 hover:text-primary-600"
    @click="toggleRevealed"
    v-tooltip.top="'Show/Hide'"
  )
    i.ph(:class="revealed ? 'ph-eye-slash' : 'ph-eye'")
</template>

<script setup>
import { computed, inject, onBeforeUnmount, ref, useAttrs } from 'vue'
import InputText from "primevue/inputtext"
import { FormField } from '@primevue/forms';
import Message from 'primevue/message';

const formSubmitted = inject('appFormSubmitted', ref(false))

const props = defineProps({
  name:           { type: String, required: false },
  label:          { type: String, required: false },
  revealDuration: { type: Number, default: 10000 },
})

const modelValue = defineModel({ required: false })

defineOptions({inheritAttrs: false})

const $attrs = useAttrs()
const inputClass = computed(() => ['pr-10', $attrs.class])

const revealed = ref(false)
let revealTimeout = null

function toggleRevealed() {
  revealed.value = !revealed.value
  clearTimeout(revealTimeout)
  if (revealed.value) {
    revealTimeout = setTimeout(() => { revealed.value = false }, props.revealDuration)
  }
}

onBeforeUnmount(() => clearTimeout(revealTimeout))
</script>

<style lang="scss" scoped>
.eye-toggle {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
